module.exports = {"id":"192629","name":"Iago Aspas","rating":"84","photo":"./data/images/photos/2/192629.png","club":{"name":"Celta Vigo","logo":"./data/images/clubs/CeltaVigo.png"},"positions":["AD","BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IagoAspas0.json
// module id = 1761
// module chunks = 0